module.exports = "/img/_/_/_/assets/images//plus.png?5560e0f4dd36bf4792a12334b8200d8b";